import { selector } from 'recoil';
import uidAtom from '../atom/uid';
import mealPickupTypeAtom from '../atom/mealPickupType';
import pickMealTimeAtom from '../atom/pickMealTime';
import preOrderDateAtom from '../atom/preOrderDate';
import locationAtom from '../atom/location';
import taxTypeAtom from '../atom/taxType';
import taxInfoAtom from '../atom/taxInfo';
import cartStatusAtom from '../atom/cartStatus';
import paymentTypeAtom from '../atom/paymentType';
import groupItemsAtom from '../atom/groupItems';
import groupHostInfoAtom from '../atom/groupHostInfo';
import couponAtom from '../atom/coupon';
import shippingFeeAtom from '../atom/shippingFee';
import emailAtom from '../atom/email';

import convertMealPickupType from '~/utils/convertMealPickupType';

import { CartType, GroupCart } from '~/types';

const groupCart = selector<GroupCart>({
  key: 'groupCart',
  get: ({ get }) => {
    const uid = get(uidAtom);
    const mealPickupType = get(mealPickupTypeAtom);
    const pickMealTime = get(pickMealTimeAtom);
    const preOrderDate = get(preOrderDateAtom);
    const location = get(locationAtom);
    const taxType = get(taxTypeAtom);
    const taxInfo = get(taxInfoAtom);
    const cartStatus = get(cartStatusAtom);
    const paymentType = get(paymentTypeAtom);
    const groupItems = get(groupItemsAtom);
    const groupHostInfo = get(groupHostInfoAtom);
    const coupon = get(couponAtom);
    const shippingFee = get(shippingFeeAtom);
    const email = get(emailAtom);

    const orderType = convertMealPickupType(mealPickupType, pickMealTime);

    return {
      cartType: CartType.GROUP,
      uid,
      orderType,
      preOrderDate,
      location,
      taxInfo,
      taxType,
      status: cartStatus,
      paymentType,
      groupItems,
      groupHostInfo,
      coupon,
      shippingFee,
      email,
    };
  },
});

export default groupCart;
